import React from 'react';

import { ClipLoader } from 'react-spinners';

import colors from '../../styles/colors.module.scss';

const Spinner = () => {
  return (
    <ClipLoader cssOverride={{ marginTop: '20px' }} color={colors.blueDark} size={25} />
  );
};

export default Spinner;
